// extracted by mini-css-extract-plugin
export default {"container":"Form_container__GRIO4","google":"Form_google__ccp6Z"};